module.exports = __webpack_public_path__ + "img/ic-arrow-right-w.c5657f0f.svg";